import React from "react";

import PropTypes from "prop-types";

import { useStylesUtil } from "utils/styleUtils";

import RbFlexTableHeadContext from "./RbFlexTableHeadContext";

const RbFlexTableHead = React.forwardRef(function RbFlexTableHead(props, ref) {
  const { children, srOnly, ...other } = props;

  const classesUtils = useStylesUtil();

  const contextValue = React.useMemo(() => {
    return {
      head: true,
    };
  }, []);

  return (
    <RbFlexTableHeadContext.Provider value={contextValue}>
      <div
        role="rowgroup"
        {...other}
        ref={ref}
        className={srOnly ? classesUtils.srOnly : ""}
      >
        {children}
      </div>
    </RbFlexTableHeadContext.Provider>
  );
});

RbFlexTableHead.propTypes = {
  children: PropTypes.node,
  srOnly: PropTypes.bool,
};

RbFlexTableHead.defaultProps = {
  children: null,
  srOnly: false,
};

export default React.memo(RbFlexTableHead);
